import { h } from 'preact';
const CloseIcon = ()=>h('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24'
    }, h('path', {
        d: 'M3.59998 3.60001L20.3999 20.3999',
        stroke: '#13294B',
        'stroke-width': '1.25',
        'stroke-linecap': 'round'
    }), h('path', {
        d: 'M3.59998 20.4L20.3999 3.60014',
        stroke: '#13294B',
        'stroke-width': '1.25',
        'stroke-linecap': 'round'
    }));
export default CloseIcon;
